import { createBrowserHistory, History } from "history";

export const history = createBrowserHistory<History>();
